import { displayDate } from '../../lib/util'

export const createTrainingReportDownloadData = (
  trainingData,
  program,
  siteName,
) => {
  const fileDate = displayDate(Date.now(), 'LLL')
  const filename = `${program} Training Report for site ${siteName} as of ${fileDate}.csv`.trim()

  const headers = [
    { label: 'Activation Key', key: 'activationKey' },
    { label: 'Attempted', key: 'attempted' },
    { label: 'Is Completed', key: 'is_done' },
    { label: 'Completed At', key: 'doneAt' },
    { label: 'Is Open', key: 'is_open' },
    { label: 'Status', key: 'status' },
    { label: 'Program', key: 'skuCode' },
    { label: 'Learner', key: 'learner' },
    { label: 'Progress', key: 'progress' },
    { label: 'Score', key: 'score' },
    { label: 'Updated At', key: 'updatedAt' },
  ]

  const trainingReportDownloadData = {
    data: trainingData,
    headers: headers,
    filename,
  }
  return trainingReportDownloadData
}

export default { createTrainingReportDownloadData }
